import TarifasView from '../TarifasView.vue'
import BasePriceList from '../Pages/BasePriceList.vue'
import CalculatedPriceList from '../Pages/CalculatedPriceList.vue'
import PriceTypeList from '../Pages/PriceTypeList.vue'
import PriceTypeEditor from '../Pages/PriceTypeEditor.vue'

const routes = [
  {
    path: '/tarifas',
    component: TarifasView,
    name: 'tarifas',
    children: [
      {
        path: 'precios-base',
        name: 'tarifas-base-price-list',
        component: BasePriceList,
      },
      {
        path: 'tarifario',
        name: 'tarifas-tarifario',
        component: CalculatedPriceList,
      },
      {
        path: 'listas-precios',
        name: 'tarifas-price-type-list',
        component: PriceTypeList,
      },
      {
        path: 'listas-precios/crear',
        name: 'tarifas-price-type-create',
        component: PriceTypeEditor,
      },
      {
        path: 'listas-precios/:id/editar',
        name: 'tarifas-price-type-edit',
        component: PriceTypeEditor,
      },
    ],
  },
]

export default routes
